import icons from "@/components/svg";
import osiguTheme from "./osigu.theme";

export default {
  colors: {
    ...osiguTheme.colors,

    primary: '#662f91',
    secondary: '#4F4F4F',
    'osg-black': '#000000',
    'osg-active': '#ffffff',
    'osg-active-border': '#662f91',
    'osg-active-font': '#662f91',
    'osg-active-icon' : '#662F91',
    'osg-active-text': '#1f3261',
  },
  icons: {
    ...osiguTheme.icons,

    'osg-logo': {
      component: icons.KoneksiPoweredByOsigu
    },
    'osg-email': {
      component: icons.KoneksiEmailIcon
    },
  }
}
